/**
 * Remotion entry — Behavioral Tension Engine registry.
 * Used by both the in-app <Player> preview and the Remotion CLI.
 */

import type { SimulationContent } from "@/lib/contentGenerator";
import { SpiralTemplate } from "./templates/SpiralTemplate";
import { ReplayTemplate } from "./templates/ReplayTemplate";
import { POVTemplate } from "./templates/POVTemplate";
import { ProgressionTemplate, progressionDurationFrames } from "./templates/ProgressionTemplate";
import {
  ResonantArtifactTemplate,
  resonantArtifactDurationFrames,
} from "./templates/ResonantArtifactTemplate";
import { planTimeline, FPS, WIDTH, HEIGHT } from "./utils/timing";

export type TemplateKey =
  | "spiral"
  | "replay"
  | "pov"
  | "progression"
  | "resonant";

export const TEMPLATE_REGISTRY: Record<
  TemplateKey,
  React.FC<{ sim: SimulationContent }>
> = {
  spiral: SpiralTemplate,
  replay: ReplayTemplate,
  pov: POVTemplate,
  progression: ProgressionTemplate,
  resonant: ResonantArtifactTemplate,
};

export function selectTemplate(format: string): {
  key: TemplateKey;
  Component: React.FC<{ sim: SimulationContent }>;
} {
  const key: TemplateKey =
    format === "replay"
      ? "replay"
      : format === "pov"
        ? "pov"
        : format === "progression"
          ? "progression"
          : format === "resonant"
            ? "resonant"
            : "spiral";
  return { key, Component: TEMPLATE_REGISTRY[key] };
}

export {
  planTimeline,
  FPS,
  WIDTH,
  HEIGHT,
  progressionDurationFrames,
  resonantArtifactDurationFrames,
};
